function createOverlay(image) {
  const overlay = document.createElement('div');
  prepareOverlay(overlay, image);

  image.parentElement.insertBefore(overlay, image);
  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
  container.style.pointerEvents = 'none'; // Allow mouse events to pass through to the image
}

function moveWithHover(image, event, zoomRatio, overlay) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = image.getBoundingClientRect(); // Use image rect, not event target (which might be varying)
  
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  
  // Clamp boundaries
  // (Optional, but good for edge cases)
  
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function enableZoomOnHover(zoomRatio) {
  // Only enable on devices that support hover (desktop primarily)
  if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) {
    return;
  }

  const images = document.querySelectorAll('.image-magnify-hover');
  
  images.forEach((image) => {
    let overlay = null;
    
    image.addEventListener('mouseenter', (event) => {
      // Create overlay immediately if not exists
      if (!overlay) {
        overlay = createOverlay(image);
        // Sync position immediately
        moveWithHover(image, event, zoomRatio, overlay);
      }
    });

    image.addEventListener('mousemove', (event) => {
      if (overlay) {
        moveWithHover(image, event, zoomRatio, overlay);
      }
    });

    image.addEventListener('mouseleave', () => {
      if (overlay) {
        overlay.remove();
        overlay = null;
      }
    });
  });
}

enableZoomOnHover(1.5); // Increased zoom ratio slightly for premium feel
